if (!customElements.get("product-content")) {
  class ProductContent extends HTMLElement {
    connectedCallback() {
      this.sections = [];
      this.handle = this.dataset.productContent;
      this.relatedContentTemplate = document.querySelector(
        `#related-content-${this.handle}`
      );

      this.parseSections();
      this.buildUI();
    }

    buildUI() {
      const placeholders = this.querySelectorAll(
        "[data-product-content-placeholder]"
      );

      placeholders.forEach(this.injectHTML.bind(this));
    }

    injectHTML(placeholder) {
      const componentType = placeholder.dataset.productContentPlaceholder;
      let componentHTML;

      switch (componentType) {
        case "tabs":
          componentHTML = this.getTabsHTML();
          break;
        case "accordion":
          componentHTML = this.getAccordionHTML();
          break;
        default:
      }

      placeholder.innerHTML = componentHTML;
    }

    getAccordionHTML() {
      const buttonPanel = (section, index) => {
        const heading = section.heading.textContent.replace(":", "");
        const shouldRenderRelatedContent =
          this.relatedContentTemplate && heading === "Related Content";
        let content = section.body
          .map((element) => element.outerHTML || element.textContent)
          .join("");

        if (shouldRenderRelatedContent) {
          content = this.relatedContentTemplate.innerHTML;
        }

        return `
          <button 
            type="button"
            class="accordion__button button-reset"
            id="${this.handle}-accordion-button-${index}"
            data-accordion-button="${index}"
            aria-controls="${this.handle}-accordion-panel-${index}"
            aria-expanded="false"
          >
            <span class="accordion__heading">
              ${heading}
            </span>
            <span class="accordion__icon"></span>
          </button>
          <div
            class="accordion__panel"
            id="${this.handle}-accordion-panel-${index}"
            role="region"
            data-accordion-panel="${index}"
            aria-labelledby="${this.handle}-accordion-button-${index}"
          >
            ${content}
          </div>
        `;
      };

      return `
        <wyatt-accordion class="accordion">
        ${this.sections.map(buttonPanel).join("")}
        </wyatt-accordion>
      `;
    }

    getTabsHTML() {
      const button = (section, index) => {
        const text = section.heading.textContent.replace(":", "");
        const attributes = [
          {
            name: "class",
            value: `tabs__button${
              index === 0 ? " tabs__button--active" : ""
            } button-reset`,
          },
          {
            name: "id",
            value: `${this.handle}-tab-${index}`,
          },
          {
            name: "type",
            value: "button",
          },
          {
            name: "data-tabs-button",
            value: index,
          },
          {
            name: "role",
            value: "tab",
          },
          {
            name: "aria-controls",
            value: `${this.handle}-tabpanel-${index}`,
          },
        ];

        if (index === 0) {
          attributes.push({
            name: "aria-selected",
            value: "true",
          });
        } else {
          attributes.push({
            name: "tabindex",
            value: "-1",
          });
        }

        return `
          <button ${attributes
            .map(({ name, value }) => `${name}="${value}"`)
            .join(" ")}>
            <span class="tabs__button-text">${text}</span>
          </button>
        `;
      };

      const panel = (section, index) => {
        const elements = section.body;
        const text = section.heading.textContent.replace(":", "");
        const attributes = [
          {
            name: "class",
            value: `tabs__panel${index === 0 ? " tabs__panel--active" : ""}`,
          },
          {
            name: "id",
            value: `${this.handle}-tabpanel-${index}`,
          },
          {
            name: "data-tabs-panel",
            value: index,
          },
          {
            name: "role",
            value: "tabpanel",
          },
          {
            name: "tabindex",
            value: "0",
          },
          {
            name: "aria-labelledby",
            value: `${this.handle}-tab-${index}`,
          },
        ];
        const shouldRenderRelatedContent =
          this.relatedContentTemplate && text === "Related Content";
        let content = elements
          .map((element) => element.outerHTML || element.textContent)
          .join("");

        if (shouldRenderRelatedContent) {
          content = this.relatedContentTemplate.innerHTML;
        }

        return `
          <div ${attributes
            .map(({ name, value }) => `${name}="${value}"`)
            .join(" ")}>
            ${content}
          </div>
        `;
      };

      return `
        <wyatt-tabs class="tabs">
          <div role="tablist" aria-labelledby="product-content-heading" class="tabs__buttons">
            ${this.sections.map(button).join("")}
          </div>
          <div class="tabs__panels">
            ${this.sections.map(panel).join("")}
          </div>
        </wyatt-tabs>
      `;
    }

    parseSections() {
      const { description } = WYATT.shopify.product[this.handle];

      const DOM = new DOMParser().parseFromString(description, "text/html");

      this.addHeadings(DOM);
      this.addBodyElements(DOM);
    }

    addHeadings(DOM) {
      const headings = DOM.querySelectorAll("h3");

      headings.forEach((heading) => {
        this.sections.push({
          heading,
          body: [],
        });
      });
    }

    addBodyElements(DOM) {
      const children = DOM.body.childNodes;
      let currentSection;

      children.forEach((node) => {
        const newSection = node.nodeName === "H3";

        if (newSection) {
          currentSection = this.sections.find(
            ({ heading }) => heading === node
          );
        } else if (currentSection) {
          currentSection.body.push(node);
        }
      });
    }
  }

  customElements.define("product-content", ProductContent);
}
